import { readableDate } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { TDependantFieldsFragment, TDependantType } from '../../generated/graphql';
import { TRecipientType, isDependant } from '../recipients/shared';

export const getReadableRelationshipType = (recipient?: TRecipientType | TDependantFieldsFragment) => {
  if (recipient == null || !isDependant(recipient)) return null;

  switch (recipient.type) {
    case TDependantType.Child:
      return 'Child';
    case TDependantType.Pet:
      return recipient.petType;
    case TDependantType.SignificantOther:
      // return 'Significant Other';
      return 'Spouse';
    default:
      return null;
  }
};

export const getReadableDependant = (dependant: TDependantFieldsFragment) => {
  const name = dependant.fullName || `${dependant.firstName ?? ''} ${dependant.lastName ?? ''}`.trim() || 'Unnamed dependant';
  const relationship = getReadableRelationshipType(dependant) || 'Pet';
  const birthDate = dependant.birthDate ? `Born ${readableDate(dependant.birthDate)}` : 'Birth date missing';

  return `${name} (${relationship}) — ${birthDate}`;
};
